import { createActionCreator } from "deox";

import { BookingEvent } from "../../../types/models";
export const upcomingEventsLoading = createActionCreator("upcomingEventsLoading");
export const upcomingEventsLoaded = createActionCreator(
  "upcomingEventsLoaded",
  (resolve) => (events: BookingEvent[]) => resolve(events)
);
export const upcomingEventsLoadingError = createActionCreator("upcomingEventsLoadingError");
